'use client'
import { EdsnFooter } from '@8percent/edsn-react'

type Props = {
  topMargin?: string
}

export default function Footer(props: Props) {
  return (
    <div style={{ marginTop: props.topMargin || '0px' }}>
      <EdsnFooter />
    </div>
  )
}
